// @flow
import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

import userReducer from '../services/authService/authReducer';
import testReducer from '../components/containers/test1/test1Reducer';
import sideMenuReducer from '../components/commons/sideMenu/sideMenuRedux/sideMenuReducer';
import menuBarReducer from '../components/commons/menuBar/menuBarRedux/menuBarReducer';
import switchClientDropdownReducer from '../components/commons/switchClientDropdown/switchClientDropdownRedux/switchClientDropdownReducer';
import tabViewReducer from '../components/commons/tabView/tabViewRedux/tabViewReducer';
import pageReducer from '../services/pageService/pageReducer';
import createOaModalReducer from '../components/commons/createOaModal/createOaModalRedux/createOaModalReducer';
import deactivateOaModalReducer from '../components/commons/deactivateOaModal/deactivateOaModalRedux/deactivateOaModalReducer';
import oaManagerReducer from '../components/containers/oaManager/oaManagerRedux/oaManagerReducer';
import retailCollectionsReducer from '../components/containers/retailCollections/retailCollectionsRedux/retailCollectionsReducer';
import retailCashbookReducer from '../components/containers/retailCashbook/retailCashbookRedux/retailCashbookReducer';
import collectionsHandoverReducer from '../components/containers/collectionsHandover/collectionsHandoverRedux/collectionsHandoverReducer';
import clientCommunicationReducer from '../components/containers/clientCommunication/clientCommunicationRedux/clientCommunicationReducer';
import createPrqReducer from '../components/containers/pickup/createPrq/createPrqRedux/createPrqReducer';
import crmCallingReducer from '../components/containers/crmCalling/crmCallingRedux/crmCallingReducer';
import createBulkCnReducer from '../components/containers/createBulkCn/createBulkCnRedux/createBulkCnReducer';
import initServiceReducer from '../services/initService/initServiceReducer';
import pincodeReducer from '../services/pincodeService/pincodeReducer';
import clientAddressReducer from '../services/clientAddressService/clientAddressReducer';
import pickupDashboardReducer from '../components/containers/pickup/dashboard/pickupDashboardRedux/pickupDashboardReducer';
import depositSlipReducers from '../components/containers/retailCashbook/depositSlip/depositSlipRedux/depositSlipReducer';
import masterCellDataReducer from '../components/containers/shopFloorManagement/masterData/masterDataRedux/masterDataReducer';
import addCellPrefixModalReducer from '../components/commons/addCellPrefixModal/addCellPrefixModalRedux/addCellPrefixModalReducer';
import zoneReducer from '../components/containers/shopFloorManagement/zone/zoneRedux/zoneReducer';
import createLaneReducer from '../components/containers/shopFloorManagement/createLane/createLaneRedux/createLaneReducer';
import attachmentReducer from '../components/commons/attachments/attachmentsRedux/attachmentReducer';
import nationalLineHaulReducers from '../components/containers/networkPlanning/nationalLineHaul/nationalLineHaulRedux/nlhReducer';
import newConfigurationPageReducer from '../components/containers/networkPlanning/newConfigurationPage/newConfigurationPageRedux/newConfigurationPageReducers';
import bpPassbookDashboardReducer from '../components/containers/bpPassbook/dashboard/bpPassbookDashboardRedux/bpPassbookDashboardReducer';
import createQcTicketReducer from '../components/containers/createQcTicket/createQcTicketRedux/createQcTicketReducer';
import trackingDashboardReducer from '../components/containers/bulkCn/dashboard/trackingDashboardRedux/trackingDashboardReducer';
import blockCnDashboardReducer from '../components/containers/blockCN/dashboard/blockCNDashboardRedux/blockCNDashboardReducer';
import incompleteCnDashboardReducer from '../components/containers/incompleteCn/dashboard/incompleteCnDashboardRedux/incompleteCnDashboardReducer';
import ceTaskboardReducer from '../components/containers/ceTaskboard/ceTaskboardRedux/ceTaskboardReducer';
import depositSlipDashboardReducer from '../components/containers/depositSlip/dashboard/depositSlipDashboardRedux/depositSlipDashboardReducer';
import clientSearchReducer from '../components/commons/clientSearch/clientSearchRedux/clientSearchReducer';
import loginReducer from '../services/loginService/loginReducer';
import createPrqV3Reducer from '../components/containers/pickup/createPrqV3/createPrqV3Redux/createPrqV3Reducer';
import mapViewReducer from '../components/containers/mapView/mapViewRedux/mapViewReducer';
import addressFloorTaggingReducer from '../components/containers/addressFloorTagging/addressFloorTaggingRedux/addressFloorTaggingReducer';
import epodReducer from '../components/containers/epod/epodRedux/epodReducer';
import vasChargesReducer from '../components/containers/vasCharges/vasChargesRedux/vasChargesReducer';
import bulkCnUsingExcelReducer from '../components/containers/bulkCnUsingExcel/bulkCnUsingExcelRedux/bulkCnUsingExcelReducer';
import manageVehiclesReducer from '../components/containers/manageVehicles/manageVehiclesRedux/manageVehiclesReducer';
import documentCheckerReducer from '../components/containers/documentChecker/documentCheckerRedux/documentCheckerReducer';
import bulkPincodeCheckReducer from '../components/containers/bulkPincodeCheck/bulkPincodeCheckRedux/bulkPincodeCheckReducer';
import pickupTrackingReducer from '../components/containers/pickup/pickupTracking/pickupTrackingRedux/pickupTrackingReducer';
import servicePerformanceReducer from '../components/containers/servicePerformance/servicePerformanceRedux/servicePerformanceReducer';
import deliveryApprovalReducer from '../components/containers/deliverApprovals/deliveryApprovalRedux/deliveryApprovalReducer';
import PrsDrsCostApprovalReducer from '../components/containers/prsDrsCostApproval/prsDrsCostApproval/prsDrsCostApprovalReducer';
import rpCollectionsReducer from '../components/containers/rpCollections/rpCollectionsRedux/rpCollectionsReducer';
import airFlowReducer from '../components/containers/airflow/airflowRedux/airflowReducer';
import damageCnUnblockAndRtoDashboardReducer from '../components/containers/damageCnUnblockAndRto/dashboard/dashboardRedux/damageCnUnblockAndRtoDashboardReducer';
import cmsReducer from '../components/containers/cms/cmsRedux/cmsReducer';

import chargeReconciliationReducer from '../components/containers/chargeReconciliation/redux/chargeReconciliationReducer';

const rootReducer = combineReducers({
  userProfile: userReducer,
  testState: testReducer,
  sideMenuState: sideMenuReducer,
  menuBarState: menuBarReducer,
  switchClientDropdownState: switchClientDropdownReducer,
  toastr: toastrReducer,
  tabViewState: tabViewReducer,
  oaManagerState: oaManagerReducer,
  masterDataState: masterCellDataReducer,
  pageState: pageReducer,
  createOaModalState: createOaModalReducer,
  deactivateOaModalState: deactivateOaModalReducer,
  retailCollectionsState: retailCollectionsReducer,
  retailCashbookState: retailCashbookReducer,
  collectionsHandoverState: collectionsHandoverReducer,
  clientCommunicationState: clientCommunicationReducer,
  prqCreationState: createPrqReducer,
  prqV3CreationState: createPrqV3Reducer,
  crmCallingState: crmCallingReducer,
  bulkCnCreationState: createBulkCnReducer,
  initServiceState: initServiceReducer,
  pincodeState: pincodeReducer,
  clientAddressState: clientAddressReducer,
  pickupDashboardState: pickupDashboardReducer,
  depositSlipState: depositSlipReducers,
  depositSlipDashboardState: depositSlipDashboardReducer,
  addCellPrefixModalState: addCellPrefixModalReducer,
  zoneState: zoneReducer,
  createLaneState: createLaneReducer,
  attachmentState: attachmentReducer,
  nationalLineHaulState: nationalLineHaulReducers,
  networkConfigurationPageState: newConfigurationPageReducer,
  bpPassbookDashboardState: bpPassbookDashboardReducer,
  createQcTicketState: createQcTicketReducer,
  trackingDashboardState: trackingDashboardReducer,
  blockCnDashboardState: blockCnDashboardReducer,
  incompleteCnDashboardState: incompleteCnDashboardReducer,
  ceTaskboardState: ceTaskboardReducer,
  loginState: loginReducer,
  clientSearch: clientSearchReducer,
  mapViewState: mapViewReducer,
  epodState: epodReducer,
  vasChargesState: vasChargesReducer,
  addressFloorTaggingState: addressFloorTaggingReducer,
  manageVehiclesState: manageVehiclesReducer,
  bulkCnUsingExcelState: bulkCnUsingExcelReducer,
  documentCheckerState: documentCheckerReducer,
  bulkPincodeCheckState: bulkPincodeCheckReducer,
  pickupTrackData: pickupTrackingReducer,
  servicePerformanceData: servicePerformanceReducer,
  deliveryApprovalState: deliveryApprovalReducer,
  prsDrsCostApprovalState: PrsDrsCostApprovalReducer,
  rpCollectionsData: rpCollectionsReducer,
  cmsData: cmsReducer,
  airflowState: airFlowReducer,
  damageCnUnblockAndRtoDashboardState: damageCnUnblockAndRtoDashboardReducer,
  chargeReconciliationState: chargeReconciliationReducer
});

export default rootReducer;
